import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The ten pros and cons of unit testing",
  "description": "",
  "published": "2009-08-04T00:00:00.000Z",
  "redirect_from": ["/blog/the-ten-pros-and-cons-of-unit-testing/swizec/679"],
  "categories": "Programming, Software testing, Twitulater, Uncategorized, unit test",
  "hero": "./img/2593-3788230354_c9ec0f8daa_m.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://www.flickr.com/photos/41864721@N00/3788230354/"
          }}><figure parentName="a" {...{
              "className": "gatsby-resp-image-figure",
              "style": {
                "textAlign": "center",
                "fontStyle": "italic"
              }
            }}>{`
    `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "240px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "100%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'400\\'%20viewBox=\\'0%200%20400%20400\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%204c0%205%202%207%208%207l8%204h2c2%200%207%204%2016%2016l7%207%209%204%202%203%201%205c0%202%201%203%203%205%205%203%204%203%208-1l6-4%202-1%202-1%203-1%203-1%207-1%205-2c4-1%204-2%200-9-2-5-2-6-2-13v-9l-5-2c-4-2-4-2-15-1H53c-4%200-13-4-13-7%200-2-2-2-20-2H0v4m301-3l-7%203-8%204-5%203-4%203-4%202-1%201-16%209c-1%201-10%207-12%2010l-5%202-2%203-3%201-2%201-3%203-3%203c0%203-7%206-16%207-11%201-25%200-30-1s-12%201-17%205l-7%206c-2%200-4%202-5%203l-3%201-4%202-11%204-31%208c-6%203-22%202-26%200l-2-2-10-11-2-1-2-2-1-3-1-1v-3c-2-1-2-1-9%202l-9%204-4%201c-2%202-12%203-12%202l-13-3-6-2-4-3-1%20150v150h4c4%200%205%201%209%204%205%205%207%2010%204%2010l-1%201c0%203-8%205-12%205l-4-1v19h67a1090%201090%200%200061-2l-10-4a246%20246%200%2000-19-9l-1-1c-2%200-9-5-13-9l-4-3-1-2-2-2c-2%200-4-5-4-12l-1-4%204-3c5-4%209-10%207-13-1-2%200-4%206-7l4-2%202-1h2v-1c-4%200-2-2%202-2h5c-1%201-1%201%201%201l3%202%206%201%209%202%2013%204%2010%203%2013%203%209%202%207%201h11l-4%201c-2%200-3%201-1%201l2%201%203%201%204%202c2%202%206%202%208%201%202-2%2017%2010%2017%2013%200%201%201%202%202%201l4%201%205%202%2011-2%206-2%202-2c1-2%203-3%204-2%201%200%202-1%202-4l3-4%201-4%202-4c2%200%203-2%201-2v-3l1-4%201-2v-2l-1-5c1-3%200-4-1-4-2%200-3-1-2-3l1-4c1-13%2011-45%2012-41%200%203%207%203%2010%200l4-4c5-2%206-6%205-14l1-6c2%200%201-5-3-7l-4-4c-2-4-4-5-4-2l1-23a792%20792%200%2000-1-12%20282%20282%200%2001-6%2027l-1-12-1-16%202-2c1%201%202-6%202-10l-2-8c-1-6-2-7-8-5-8%203-12%207-13%2013-1%205-4%207-10%207-5%200-7-4-6-13l1-14c0-5%200-7%202-8%202%200%201-2-1-2-3%201-3-1%200-4l2-5c-1-1%200-4%201-6%201-3%201-3-1-4-4-1-4-3-1-4%202-1%203-3%201-3s-4%200-6-2l-4-2-1-2c0-2%201-3%202-3l1%201c-1%202%202%202%202%200%201-2%201-2%204-1%202%202%202%202%201%200v-7c-1-3-1-5-4-7s-2-3%202%200h3l3-1c2%200%204-2%202-3-1-1-1-1%201-1%202%201%203%200%200-2-1-3-1-5%201-4l1-1h1c2%202%202%202%204%200l3-2%202-8c0-2%200-2%202%200%203%201%203%201%207-3l6-4%205-3%207-5%201%201c1%202%2010%200%2010-2%200-1%202-1%203%201l1%201%205%205c2%204%203%204%206%203%204%200%208-2%2011-4%204-3%2012-3%2026-2%2010%201%2011%201%2017%205%208%206%2010%208%2012%2013l3%204%202%204c3%204%208%206%2014%204%203%200%203-1%203-4v-5c1-1%201%201%201%207v8h-5c-5%200-10%202-15%207s-7%208-6%2019c0%2012-1%2017-6%2023l-5%207-3%207c-2%201-3%203-3%205s-2%207-4%209l-2%208a320%20320%200%2001-2%2020l3%2020%201%205v28l-8%209c-7%206-7%207-6%209l2%203%202%203%208%207%205%205v7c0%205-1%207-2%208l-2%203c0%201-5%206-7%206l-1%201-6%202-8%202-11%202a90%2090%200%2000-29%204l-6%202-10%2011-5%2011%203%201%206%202c2%202%207%203%2010%204l9%203%204%201%206%201c4%202%2015%204%2022%205l15%201%2019%202%2033%203h4V5h-5c-3%200-8%203-11%206l-4%202-6%204c-1%201-3%202-8%202l-5%203c-4%203-4%207-1%2012%203%204%202%206-1%209-2%202-3%202-8%202-6-1-8-2-6-3%201-1-1-6-4-10l-2-8c0-9-1-10-6-13l-8-3-6-4c-5-4-11-5-18-3m-16%20125l-1%202c-2%201-4%200-3-1l-2-1c-3%200-5%202-3%202l2%204%202%204h6c5%201%206%201%206%203l1%204%201-3%201-4v-2l-1-2c0-2-2-3-4-3l-3-2-1-2c-1-1-1%200-1%201m-30%206c-2%203-2%204-1%206%202%202%208%206%2011%206l5%204c1%201%202%202%204%201%203%200%207%202%207%205%201%202%201%201%201-1%200-3%201-4%202-5%203-2%200-3-7-2-5%202-6%202-6%200l-4-2c-9-4-9-5-10-11v-5l-2%204m138%20109c-5%203-11%2011-11%2014l-9%2011c-9%209-10%2010-11%2015%200%205%200%2013%202%2016l3%202c9%2012%2016%2017%2020%2016l7%201%205%202%201-40-1-41-6%204m-140%2039c0%203-2%203-7%204l-7%201-15%202-3%201%207%2011%201%202%203%204%202%204%2010%204%204-1c1-1%202-2%203-1%202%201%203%200%202-6-1-5-1-14%202-24l-1-3-1%202m-69%2095l-1%201-3%205-4%206-2%203c0%202-4%206-7%207l-3%202%2026%201c27%200%2030%200%2023-4l-5-4-4-3-1-2-1-3-2-1c0-2-5-7-7-7l-1-1c0-2-1-2-4-2s-4%200-4%202\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                    "srcSet": ["/static/3e8743473a1ff3b28b20ed6b3f7a2881/ca0a1/2593-3788230354_c9ec0f8daa_m.webp 223w", "/static/3e8743473a1ff3b28b20ed6b3f7a2881/8ac56/2593-3788230354_c9ec0f8daa_m.webp 240w"],
                    "sizes": "(max-width: 240px) 100vw, 240px",
                    "type": "image/webp"
                  }}></source>{`
          `}<source parentName="picture" {...{
                    "srcSet": ["/static/3e8743473a1ff3b28b20ed6b3f7a2881/853b2/2593-3788230354_c9ec0f8daa_m.jpg 223w", "/static/3e8743473a1ff3b28b20ed6b3f7a2881/09b79/2593-3788230354_c9ec0f8daa_m.jpg 240w"],
                    "sizes": "(max-width: 240px) 100vw, 240px",
                    "type": "image/jpeg"
                  }}></source>{`
          `}<img parentName="picture" {...{
                    "className": "gatsby-resp-image-image",
                    "src": "/static/3e8743473a1ff3b28b20ed6b3f7a2881/09b79/2593-3788230354_c9ec0f8daa_m.jpg",
                    "alt": "Last Act of the Fallen",
                    "title": "Last Act of the Fallen",
                    "loading": "lazy",
                    "style": {
                      "width": "100%",
                      "height": "100%",
                      "margin": "0",
                      "verticalAlign": "middle",
                      "position": "absolute",
                      "top": "0",
                      "left": "0"
                    }
                  }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
                "className": "gatsby-resp-image-figcaption"
              }}>{`Last Act of the Fallen`}</figcaption>{`
  `}</figure></a></p>
        <p parentName="li">{`Image by `}<a parentName="p" {...{
            "href": "http://www.flickr.com/photos/41864721@N00/3788230354/"
          }}>{`ecstaticist`}</a>{` via Flickr`}</p>
      </li>
    </ul>
    <p>{`Some of you may remember my writing about how `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/unit-testing-is-anti-productive/swizec/610"
      }}>{`unit testing is anti-productive`}</a>{` and those of you I have to disapoint, I still dont' think it's the best `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Productivity",
        "title": "Productivity"
      }}>{`productivity`}</a>{` tool out there.`}</p>
    <p>{`BUT!`}</p>
    <p>{`The past few days I had another go at unit testing while developing a "server" for gathering statistics on how people use `}<a parentName="p" {...{
        "href": "http://twitulater.com",
        "title": "Twitulater"
      }}>{`Twitulater`}</a>{`. This was mostly in preparation for making a "server" for syncing Twitulater users, more on that some other day, it was mostly a learning exercise.`}</p>
    <p>{`What I learned was that:`}</p>
    <ol>
      <li parentName="ol">{`Unit testing is no guarantee for quality `}<em parentName="li">{`(con)`}</em></li>
      <li parentName="ol">{`Unit testing can be really cumbersome to use and more time can be spent finding a `}<a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/Software_testing",
          "title": "Software testing"
        }}>{`test`}</a>{` than solving the problem. Like for example: How do you test an app that reads from sys.stdin? `}<em parentName="li">{`(con)`}</em></li>
      <li parentName="ol">{`Unit testing only helps with bugs you've anticipated or found`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      